import { Tooltip, Chip, Typography, Box } from "@material-ui/core";
import { withStyles, makeStyles } from "@material-ui/core/styles";

import { Color } from "@bonliva-crm/ui";
import { transparentize } from "polished";
import { slice } from "lodash";

const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: theme.shadows[1],
    fontSize: 11
  }
}))(Tooltip);

export const TagsRenderer = ({ tags = [] }: { tags: string[] }) => {
  return (
    tags?.length > 0 && (
      <LightTooltip title={<Tags tags={tags} wrap />}>
        <div style={{ padding: "5px 0" }}>
          <Tags tags={tags} maxCount={3} />
        </div>
      </LightTooltip>
    )
  );
};

const Tags = (props: { tags: string[]; maxCount?: number; wrap?: boolean }) => {
  const maxCount = props.maxCount || props.tags?.length;
  const classes = useStyles();
  const tags =
    props.tags.length > props.maxCount ? slice(props.tags, 0, maxCount) : props.tags;
  return (
    <Box
      className={classes.root}
      flexWrap={props.wrap ? "wrap" : "nowrap"}
      display={"flex"}
      alignItems={"center"}
    >
      {tags.map((tag) => (
        <Chip
          key={tag}
          size="small"
          variant="outlined"
          label={
            <Typography variant="subtitle1" style={{ color: Color.Body }}>
              {tag}
            </Typography>
          }
          style={{
            padding: "2px 4px 2px 2px",
            backgroundColor: transparentize(0.75, Color.DoveBlue)
          }}
        />
      ))}
      {props.tags.length > maxCount && (
        <Typography
          className={classes.overflowCount}
          variant="subtitle1"
          style={{ color: Color.Body }}
        >
          {`+${props.tags.length - maxCount}`}
        </Typography>
      )}
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    padding: 5,
    gap: 5,
    position: "relative"
  },
  overflowCount: {
    position: "sticky",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    right: 0,
    top: 0,
    background: "linear-gradient(to right, transparent 15%, white 50%)",
    width: "30px",
    height: "25px"
  }
}));
